import { render } from "./CookiesDropDown.vue?vue&type=template&id=547d2c4a&scoped=true"
import script from "./CookiesDropDown.vue?vue&type=script&lang=js"
export * from "./CookiesDropDown.vue?vue&type=script&lang=js"

import "./CookiesDropDown.vue?vue&type=style&index=0&id=547d2c4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547d2c4a"]])

export default __exports__